//
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Icon, Row, Col, Tabs, message } from 'antd';
import './style.css';

import { getCookie } from '../../hook';
// Actions
import { get_leave_approvals, set_leave_approvals, get_leave_type, set_leave_type } from './actions/approvals.action';
// Childs
import LeaveApprovals from './childs/leave.approvals';

const TabPane = Tabs.TabPane;

class Approvals extends Component {

    constructor( props ){
        
        super( props );

        this.state = {
            leave_list: [],
            leave_types: []
        }

        this.handleApprove = this.handleApprove.bind( this );
        this.handleLeaveType = this.handleLeaveType.bind( this );

    }

    handleLeaveType( leave_id, leave_type_id ){
        this.props.set_leave_type( leave_id, leave_type_id );
    }

    handleApprove( id, remarks ){
        let user = getCookie('dv_hrms_user').split(',');
        this.props.set_leave_approvals( user[1], id, remarks );
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.approval.length === 0 ){
            console.log( 'Slow Data Fetching ...' )
            return false;
        }
        
        if( nextProps.approval.STATUS.CODE === "200" && 
            nextProps.approval.STATUS.MESSAGE === "Successfully Listed Leaves" ) {
            this.setState({
                leave_list: nextProps.approval.OUTPUT.DATA
            })

        } else if( nextProps.approval.STATUS.CODE === "200" && 
            nextProps.approval.STATUS.MESSAGE === "Successfully Approved Leave" ) {

            let user = getCookie('dv_hrms_user').split(',');
            this.props.get_leave_approvals( user[6], '0,1' );

            message.success( "Successfully Updated" );
        
        } else if( nextProps.approval.STATUS.CODE === "200" && 
            nextProps.approval.STATUS.MESSAGE === "Successfully Listed Leave Type" ) {
            
            this.setState({
                leave_types: nextProps.approval.OUTPUT.DATA
            })

        } else if( nextProps.approval.STATUS.CODE === "400" ) {
            message.error( nextProps.approval.STATUS.MESSAGE );

        }

    }

    componentWillMount(){
        
        let user = getCookie('dv_hrms_user').split(',');
        this.props.get_leave_type();

        if( typeof this.props.match.params.id !== "undefined" ){
            this.props.get_leave_approvals( this.props.match.params.id, 0 );
            return false;
        }

        this.props.get_leave_approvals( user[6], '0,1' );

    }
    
    render() {
        
        return (
            <div className="approvals_wrapper">
                
                <Row>
                    <Col span={24}>
                        <h2>
                            <Icon type="check-circle-o" />
                            &nbsp; Approvals
                        </h2>
                    </Col>
                </Row>

                <Row>
                    <Col span={24}>
                        <LeaveApprovals 
                            onHandleType={ this.handleLeaveType }
                            onApprove={ this.handleApprove } 
                            data={ this.state.leave_list }
                            dataLeaveType={ this.state.leave_types } />
                    </Col>
                </Row>

            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        approval: state.approval
    }
}

export default connect( mapStatetoProps, { get_leave_approvals, set_leave_approvals, get_leave_type, set_leave_type } )( Approvals );



// WEBPACK FOOTER //
// ./src/pages/approvals/index.js